/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { FILTER_NAMES } from "@/static/filterNames";
import { DataOptions } from "vuetify";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import {
  getReservationsToStatementTable,
  getReservationsMatchedToStatementTable,
} from "@/requests/finances/requestsBankOperations";
import { GetBankStatementReservation } from "@/models/api/finances/GetBankStatementReservationsResponse";

/* eslint-disable-next-line */
export interface bankOperationsPurchaseRightPanelStateInterface {
  isLoading: boolean;
  dataTableData: Array<GetBankStatementReservation>;
  dataTableOptions: DataOptions;
  countServerSide: number;
  filters: null | Array<CriterionItemRequest>;
}

export const bankOperationsPurchaseRightPanelState: bankOperationsPurchaseRightPanelStateInterface = {
  isLoading: false,
  dataTableData: [],
  dataTableOptions: new DefaultDataOptions(),
  countServerSide: -1,
  filters: null,
};

const bankOperationsPurchaseRightPanelModule = defineModule({
  state: bankOperationsPurchaseRightPanelState as bankOperationsPurchaseRightPanelStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsLoading(state, param: boolean) {
      state.isLoading = param;
    },
    setDataTableData(state, param: Array<GetBankStatementReservation>) {
      state.dataTableData = param;
    },
    setDataTableOptions(state, param: DataOptions) {
      state.dataTableOptions = JSON.parse(JSON.stringify(param));
    },
    setCountServerSide(state, param: number) {
      state.countServerSide = param;
    },
    setFilters(state, param: Array<CriterionItemRequest>) {
      state.filters = param;
    },
  },
  actions: {
    async getDataTableData(context, bankItemId: number) {
      const { commit, state, rootState } = _moduleActionContext(context);
      commit.setIsLoading(true);
      let response;
      const requests = {
        count: state.dataTableOptions.itemsPerPage,
        page: state.dataTableOptions.page - 1,
        criterions: state.filters,
        filterName: FILTER_NAMES.BookingsForStatementsStandardFilter,
      };
      if (!rootState.finances.bankOperations.isDownloadTableMatched) {
        response = await getReservationsToStatementTable(requests, bankItemId);
      } else {
        response = await getReservationsMatchedToStatementTable(requests, bankItemId);
      }
      commit.setCountServerSide(response.totalCount);
      commit.setDataTableData(response.items);
      commit.setIsLoading(false);
    },
  },
});

export default bankOperationsPurchaseRightPanelModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, bankOperationsPurchaseRightPanelModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, bankOperationsPurchaseRightPanelModule);
